import { getRedirectResult } from 'firebase/auth';
import { firebaseAuth } from '@services/firebase';
import { IUser, useUser } from '@providers/UserProvider';
import { useLayoutEffect } from 'react';

export function useCheckAuth() {
  const { setUser } = useUser();

  useLayoutEffect(() => {
    getRedirectResult(firebaseAuth)
      .then((response) => {
        if (response?.user) {
          const providerData = response.user.providerData.find(
            (provider) => provider.providerId === response.providerId
          );

          const user = {
            uid: response.user.uid,
            email: response.user.email ?? '',
            providerId: providerData?.providerId as IUser['providerId'],
            providerDataId: providerData?.uid as IUser['providerDataId'],
            isAppleAuth: providerData?.providerId === 'apple.com',
            isGoogleAuth: providerData?.providerId === 'google.com',
          };

          setUser(user);
        }
      })
      .catch(console.error);
  }, []);
}
